import { baseURL } from "../utils/constants";
import axiosInstance from "../utils/axiosUtil";

export const getResourcesByHospitalId= async (hospital_id: string) => {
    try {
      const res = await axiosInstance.get(`${baseURL}/resource/${hospital_id}`);
      return res;
    } catch (error: any) {
      if (error.response || error.response.status === 403) {
        return error.response;
      } else {
        console.error(error);
      }
    }
  };